module.exports = __webpack_public_path__ + "img/108ne.52fa7c4c.svg";